import { lazy } from "react";

const Quadratures = lazy(() => import("./Quadratures"));

/**
 * The Cost Center Page.
 */
const QuadraturesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "quadratures",
      element: <Quadratures />,
    },
  ],
};

export default QuadraturesConfig;
